import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { ImagePlus, Trash2, Loader2, ImageOff } from "lucide-react";
import { toast } from "sonner";

export const RecipePhoto = ({ recipe, canEdit, onChanged, className = "" }) => {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    let revoke = null;
    setUrl(null);
    if (recipe.photo_version) {
      api.get(`/recipes/${recipe.id}/photo`, { responseType: "blob" })
        .then((r) => { revoke = URL.createObjectURL(r.data); setUrl(revoke); })
        .catch(() => setUrl(null));
    }
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [recipe.id, recipe.photo_version]);

  const upload = async (file) => {
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    setBusy(true);
    try { await api.post(`/recipes/${recipe.id}/photo`, fd); toast.success("Fotoğraf yüklendi"); onChanged(); }
    catch (e) { toast.error(e.response?.data?.detail || "Yükleme başarısız"); }
    setBusy(false);
  };
  const remove = async () => {
    setBusy(true);
    try { await api.delete(`/recipes/${recipe.id}/photo`); toast.success("Fotoğraf kaldırıldı"); onChanged(); }
    catch (e) { toast.error("Kaldırılamadı"); }
    setBusy(false);
  };

  return (
    <div className={`group relative overflow-hidden rounded-xl border border-border bg-secondary/30 ${className}`} data-testid={`recipe-photo-${recipe.id}`}>
      {url ? <img src={url} alt={recipe.display_name} className="h-full w-full object-cover" data-testid="recipe-photo-img" />
        : <div className="flex h-full w-full flex-col items-center justify-center text-muted-foreground"><ImageOff className="h-8 w-8 opacity-30" /><span className="mt-1 text-xs">{recipe.photo_version ? "Yükleniyor…" : "Fotoğraf yok"}</span></div>}
      {canEdit && (
        <div className="absolute inset-x-0 bottom-0 flex justify-end gap-1 bg-gradient-to-t from-black/70 to-transparent p-2 opacity-0 transition-opacity group-hover:opacity-100 print:hidden">
          <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" data-testid="recipe-photo-input" onChange={(e) => { upload(e.target.files?.[0]); e.target.value = ""; }} />
          <Button size="sm" variant="secondary" className="h-7" disabled={busy} data-testid="recipe-photo-upload" onClick={() => inputRef.current?.click()}>
            {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ImagePlus className="mr-1 h-3.5 w-3.5" />} {url ? "Değiştir" : "Fotoğraf Yükle"}
          </Button>
          {url && <Button size="sm" variant="secondary" className="h-7" disabled={busy} data-testid="recipe-photo-delete" onClick={remove}><Trash2 className="h-3.5 w-3.5 text-destructive" /></Button>}
        </div>
      )}
    </div>
  );
};
